export default __webpack_public_path__ + "static/media/2x.7b3d7f10.svg";